import { Page, View, Text, Image } from '@react-pdf/renderer';
import { styles } from './styles';
import {
  PublicEventDetailsResponse,
  PublicExhibitionItem,
} from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { styles as rootStyle } from './../../styles';
import { useTranslation } from 'react-i18next';
import { getImageSrc } from '@utils/fn';

export interface PartnerThisYearPageProps {
  event: PublicEventDetailsResponse;
  exhibitions: PublicExhibitionItem[];
  footer: JSX.Element;
}

const PartnerThisYearPage = ({
  event,
  exhibitions,
  footer,
}: PartnerThisYearPageProps) => {
  const { t } = useTranslation();

  const exhibitionsList = exhibitions?.filter(
    (attendee: PublicExhibitionItem) => attendee?.company?.logo
  );

  return (
    <Page size={{ width: 1440, height: 800 }} style={styles.page}>
      <View style={styles.fullWidthContainer}>
        <Text style={styles.pageTitle}>
          {t('partner-this-year', { eventName: event?.name ?? '' })}
        </Text>
        <View
          style={{
            ...globalStyles.lineBar,
            alignSelf: 'center',
            borderColor: event?.design?.themeColor ?? 'black',
            marginTop: 20,
            marginBottom: 30,
            width: 200,
          }}
        />

        <View style={styles.galleryContainer}>
          {(exhibitionsList || []).map((item, index) => {
            const logoSrc = getImageSrc(item?.company?.logo);
            return (
              logoSrc && (
                <View style={styles.logoWrapper}>
                  <Image key={index} style={styles.logoImage} src={logoSrc} />
                </View>
              )
            );
          })}
        </View>
      </View>

      <View style={rootStyle.footer}>
        <View
          style={{
            ...rootStyle.footerColumn,
            alignItems: 'flex-end',
            paddingRight: 70,
          }}
        >
          <Image
            style={{ width: 120 }}
            src={
              'https://media.we-conect.com/images/pdf/partnerprospectus/weCONECT_mono_black.png'
            }
          />
        </View>
      </View>
    </Page>
  );
};

export default PartnerThisYearPage;
